// Ported from the native app's ResourcesStore.swift.

import { Emitter, storageGet, storageSet } from "./storage.js";

export interface ResourceLink {
  title: string;
  subtitle: string;
  url: string;
  category: string;
}

/** Display order for known categories — unknown ones group after these. */
export const resourceCategoryOrder = ["Prop Firms", "Platforms", "Courses", "Books", "Software"];

const placeholderLinks: ResourceLink[] = [
  { title: "Placeholder prop firm", subtitle: "Add a negotiated discount link once you have one", url: "https://example.com", category: "Prop Firms" },
  { title: "Placeholder platform", subtitle: "Charting or execution platform partner", url: "https://example.com", category: "Platforms" },
  { title: "Placeholder course", subtitle: "Trading education or mentorship partner", url: "https://example.com", category: "Courses" },
  { title: "Placeholder book", subtitle: "A trading book you'd actually recommend", url: "https://example.com", category: "Books" },
  { title: "Placeholder software", subtitle: "Trader tax tools, VPN, or similar", url: "https://example.com", category: "Software" },
];

// Point this at a JSON file you control — editing that file changes what
// every installed copy shows, without a store re-review.
const remoteConfigURL = "https://tickahead.com/resources.json";
const CACHE_KEY = "cachedResourceLinks";

export class ResourcesStore {
  links: ResourceLink[] = placeholderLinks;
  readonly changed = new Emitter();

  async init(): Promise<void> {
    const cached = await storageGet<ResourceLink[]>(CACHE_KEY, []);
    if (cached.length) {
      this.links = cached;
      this.changed.emit();
    }
    void this.refresh();
  }

  async refresh(): Promise<void> {
    try {
      const response = await fetch(remoteConfigURL);
      if (!response.ok) return;
      const decoded = (await response.json()) as ResourceLink[];
      if (!Array.isArray(decoded) || !decoded.length) return;
      this.links = decoded;
      await storageSet(CACHE_KEY, decoded);
      this.changed.emit();
    } catch {
      // Offline or not set up yet — keep showing what we already had.
    }
  }
}

export const resourcesStore = new ResourcesStore();
